import Blue from "~/core";

new Blue({
	name: 'Form Validate',
	selector: ".hero a[data-audio-src]",
	setup(link) {
		const src = link.getAttribute("data-audio-src");
		let audio = new Audio(src);
		audio.load();

		this.$addEvents(audio, "play", () => link.classList.add("is-playing"));
		this.$addEvents(audio, "ended", () => link.classList.remove("is-playing"));
		this.$addEvents(audio, "error", () => link.classList.add("audio-error"));

		this.$addEvents(link, "click.prevent", () => {
			if (link.matches(".is-playing")) {
				audio.pause();
				link.classList.remove("is-playing");
			} else if (link.matches(".audio-error")) return;
			else audio.play()
		});
	}
});